import React from 'react';
import PropTypes from 'prop-types';

import HtmlText from '~/src/components/htmlText/HtmlText';
import InternalLink from '~/src/components/internalLink/InternalLink';

import {ElementTypes} from '~/src/utilities/constants/types';
import rollbar from '~/src/utilities/libs/rollbar';

const TextBlockArray = ({items}) => {
    if (!items) {
        return null;
    }

    const children = items.map((item, index) => {
        switch (item.type) {
            case ElementTypes.HTML_TEXT_ITEM:
                return <HtmlText key={index} {...item} />;
            case ElementTypes.INTERNAL_LINK:
                return <InternalLink key={index} {...item} />;
            default:
                rollbar.warning(`[TextBlockArray] Type is not supported: ${item.type}`, item);
                return null;
        }
    });

    return <p>{children}</p>;
};

if (process.env.NODE_ENV === 'development') {
    TextBlockArray.propTypes = {
        items: PropTypes.array.isRequired
    };
}

export default TextBlockArray;
